import React from "react";
import { useSelector } from "react-redux";
import { Heading, RoleName2, SubHeading } from "./BlockParts";

export default function RoleNameBlock2({ options, items, idx }) {
  let FontSettings = useSelector((state) => state.project?.fontStyle);
  const settings= useSelector((state) => state.project?.settings);
  return (
    <>
    <div className="container p-1" style={{width:"100%", padding:"0px"}} id={"block_" + idx}>
      <div className="row" style={{marginLeft:"0px", marginRight:"0px"}}>
        <div className="col" style={{ width:"100%",padding:"0px"}}>
          <Heading options={options} fontStyle={FontSettings?.heading} idx={idx} />
        </div>
      </div>
      <div className="row" style={{marginLeft:"0px", marginRight:"0px"}}>
        <div className="col"  style={{ width:"100%",padding:"0px"}}>
          <SubHeading
            options={options}
            fontStyle={FontSettings?.subHeading}
            idx={idx}
          />
        </div>
      </div>
      <div className="row" style={{marginLeft:"0px", marginRight:"0px"}}>
        <div className="col" style={{ width:"100%",padding:"0px"}}>
          <RoleName2
            options={options}
            fontStyle={FontSettings}
            idx={idx}
            items={items}
            settings={settings}
          />
        </div>
      </div>
    </div>   
    </>
  );
}
